export default __webpack_public_path__ + "static/media/logo-326x329.b1090bd2.png";